module.exports = __webpack_public_path__ + "static/img/logo1.2a6b22c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo1.svg
// module id = sDvA
// module chunks = 5